module.exports = __webpack_public_path__ + "static/media/rugby.a218f2ad.svg";